import React, { useEffect, useState } from "react";
import { BiExport } from "react-icons/bi";
import { MdClear } from "react-icons/md";
import { AxiosResponse } from "axios";
import { RenderPaginationButtons } from "../../../Components/Paginations";
import axiosInstance from "../../../api/axiosInstance";
import { useNavigate, useParams } from "react-router-dom";
import CreatableSelect, { components } from "react-select";
import { IoMdArrowRoundBack } from "react-icons/io";

interface ReportDataType {
    number: string,
    campaign_name: string,
    user: {
        name: string,
        email: string,
        role: number
    }
}
export default function OneToOneReport() {
    const [Data, setData] = useState<ReportDataType[]>([]);
    const [isExporting, setIsExporting] = useState(false);
    const { id } = useParams();
    const [users, setUsers] = useState<{ value: number; label: string }[]>([]);
    const [selectUser, setSelectUser] = useState<{ value: number; label: string }>();
    const [isReportFetching, setIsReportFetching] = useState(false);
    const [selectDateName, setSelectDateName] = useState("Today");
    const [UserSearch, setUserSearch] = useState("");
    const [isUserSearch, setIsUserSearch] = useState(false);
    const navigate = useNavigate();
    const [UserInfo, setUserInfo] = useState<{
        count: number;
        current_page: number;
        limit: number;
        total_page: number;
    }>();
    const [UserPgae, setUserPage] = useState(1);

    const [info, setInfo] = useState<{
        count: number;
        current_page: number;
        limit: number;
        total_page: number;
    }>();
    const [Filter, setFilter] = useState<{
        user_id: null | number;
        number: string;
    }>({
        user_id: null,
        number: "",
    });
    const [page, setPage] = useState(1);

    const GetReport = () => {
        setIsReportFetching(true);
        axiosInstance.get(`/api/admin/reports/one-to-one/${id}?limit=10&page=${page}&number=${Filter?.number?.replaceAll("+", "%2B")}&user_id=${Filter?.user_id || ""}`)
            .then((resp: AxiosResponse) => {
                setData(resp.data?.data || []);
                setPage(resp.data?.info?.current_page || 1);
                setInfo(resp?.data?.info);
                setIsReportFetching(false);
            }).catch(() => { setIsReportFetching(false); });
    };


    const GetUserList = () => {
        axiosInstance.get(`/api/admin/users?limit=50&search=${UserSearch}&page=${UserPgae}`)
            .then((resp: AxiosResponse) => {
                let data = isUserSearch ?
                    resp.data?.data?.map((item: any) => ({ value: item?.id, label: item?.name })) || []
                    : [...users, ...resp.data?.data?.map((item: any) => ({ value: item?.id, label: item?.name })) || []]
                setUsers(data);
                setUserPage(resp.data?.info?.current_page || 1);
                setUserInfo(resp?.data?.info);
                setIsUserSearch(false);
            }).catch(() => { setIsUserSearch(false); });
    };

    const DownloadReport = () => {
        setIsExporting(true);
        axiosInstance.get(`/api/admin/reports/one-to-one/download/${id}?limit=10&page=${page}&number=${Filter?.number?.replaceAll("+", "%2B")}&user_id=${Filter?.user_id || ""}`, { responseType: "blob" })
            .then((resp: AxiosResponse) => {
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(resp.data)
                link.download = `One_To_One_Report_${new Date().toISOString()}.xlsx`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setIsExporting(false);
            }).catch(() => { setIsExporting(false); });
    };

    useEffect(() => {
        GetReport()
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        GetUserList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [UserPgae])

    useEffect(() => {
        if (isUserSearch) GetUserList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [UserSearch])

    useEffect(() => {
        GetReport()
        // eslint-disable-next-line
    }, [page, selectDateName]);

    useEffect(() => {
        const handler = setTimeout(() => {
            GetReport()
        }, 300);

        return () => {
            clearTimeout(handler);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Filter.user_id, Filter.number]);

    const handlePageChange = (page: number) => {
        if (page > 0 && page <= (info?.total_page || 1)) {
            setPage(page);
        }
    };

    const handleClearSearchFilter = () => {
        setSelectDateName("Select Date");
        setFilter({
            user_id: null,
            number: "",
        });
        GetReport();
    };

    return (
        <div className="wrapper">
            <div className="content-wrapper">
                <section className="content">
                    <div className="container-fluid">
                        <div className="card mt-4">
                            <div className="rounded-top bg-white p-3 d-md-flex justify-content-sm-between">
                                <div className="d-flex justify-content-between w-100 flex-wrap gap-3">
                                    <h2 className="mb-0 fs-3 d-block d-md-inline">One To One Report</h2>
                                    <div className="d-flex gap-3 flex-wrap flex-grow-1 flex-md-grow-0">
                                        <button
                                            onClick={handleClearSearchFilter}
                                            className="btn btn-secondary d-flex align-items-center justify-content-center gap-2"
                                            style={{ minWidth: 130 }}
                                        >
                                            <MdClear className="fs-5" />
                                            Clear Filter
                                        </button>
                                        <button
                                            onClick={() => DownloadReport()}
                                            style={{ minWidth: 130 }}
                                            className="btn btn-success d-flex align-items-center justify-content-center gap-2 text-white"
                                            disabled={isExporting}
                                        >
                                            <BiExport className="fs-5" />
                                            {isExporting ? "Exporting.." : "Export"}

                                        </button>
                                        <button
                                            onClick={() => navigate(-1)}
                                            className="btn btn-info text-white d-flex align-items-center fw-semibold"
                                        >
                                            <IoMdArrowRoundBack /> Back
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body border-start-0 border-end-0 p-0">
                                <div className="table-responsive" style={{ minHeight: 500 }}>
                                    <table className="table table-hover table-bordered text-nowrap">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 200 }}>SR No</th>
                                                <th style={{ width: 250 }}>Number</th>
                                                <th style={{ minWidth: 350 }}>User</th>
                                                <th style={{ width: 250 }}>Role</th>
                                                <th>Campaign</th>
                                            </tr>
                                            <tr>
                                                <th></th>
                                                <th>
                                                    <input
                                                        className="form-control"
                                                        value={Filter.number}
                                                        onChange={(e) =>
                                                            setFilter({ ...Filter, number: e.target.value })
                                                        }
                                                    />
                                                </th>
                                                <th>
                                                    <CreatableSelect
                                                        name="smscampuser"
                                                        isMulti={false}
                                                        isSearchable={true}
                                                        options={users}
                                                        filterOption={(o) => true}
                                                        className='shadow-none'
                                                        value={selectUser!}
                                                        onChange={(e) => {
                                                            setSelectUser(e!)
                                                            setFilter({ ...Filter, user_id: e?.value! })
                                                        }}
                                                        isClearable
                                                        onInputChange={(inputValue) => {
                                                            setUserPage(1)
                                                            setIsUserSearch(true);
                                                            setUserSearch(inputValue)
                                                        }}
                                                        placeholder="Search and select user"
                                                        classNamePrefix="select"
                                                        styles={{
                                                        }}
                                                        components={{
                                                            IndicatorSeparator: () => null,
                                                            DropdownIndicator: () => null,
                                                            MenuList: (props) => (
                                                                <components.MenuList  {...props}>
                                                                    {props.children}
                                                                    {UserInfo?.total_page! > UserPgae ? <button className='btn btn-secondary w-100' onClick={() => setUserPage(p => p + 1)}>Load more</button> : null}
                                                                </components.MenuList >
                                                            ),
                                                        }}
                                                    />
                                                </th>
                                                <th></th>
                                                <th></th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {Data && Data[0] ? (
                                                Data.map((item, i) => (
                                                    <tr>
                                                        <td>{i + 1 + (page - 1) * 10}</td>
                                                        <td>{item?.number || " - "}</td>
                                                        <td>
                                                            <p className="mb-0">{item?.user?.name}</p>
                                                            <p className="mb-0">
                                                                <small>{item?.user?.email}</small>
                                                            </p>
                                                        </td>
                                                        <td>{item?.user?.role === 1 ? "Agent" : item?.user?.role === 2 ? "Monitor" : " - "}</td>
                                                        <td>{item?.campaign_name || " - "}</td>
                                                    </tr>
                                                ))
                                            ) : !isReportFetching ? (
                                                <tr>
                                                    <td colSpan={6} height={50}>
                                                        <div className="text-center">
                                                            <p className="mb-0 fs-5 fw-semibold">
                                                                No data found
                                                            </p>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ) : null}
                                        </tbody>
                                    </table>
                                    {isReportFetching ? (
                                        <center className="mb-3">
                                            <i
                                                className=" my-2 fa loader"
                                                style={{ fontSize: "30px", color: "black" }}
                                            ></i>
                                        </center>
                                    ) : null}
                                </div>
                                {info && info.total_page ? (
                                    <div className="pagination d-flex flex-wrap justify-content-center align-items-center my-4 mx-3">
                                        <RenderPaginationButtons
                                            info={info}
                                            currentPage={page}
                                            handlePageChange={handlePageChange}
                                        />
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}
